import React from "react";
import { Link } from "react-router-dom";

export default function CTA ({btntext, btnlink, bgcolor, hoverbgcolor}) {
    return(
        <>
            <Link to={btnlink} className={`${bgcolor} ${hoverbgcolor} cursor-target text-white font-semibold px-8 py-3 rounded-full transition-all duration-300 ease-in-out transition-transform hover:scale-103`} data-aos="zoom-out-up" data-aos-delay="500" data-aos-duration="1000" data-aos-easing="ease-in-out" >
                {btntext}
            </Link>
        </>
    )
}

// bg-[#C72430]  hover:bg-[#b91c1c]